import { DynamicItemsConfigWithArguments } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export function isDynamicItemsConfigWithArguments(
  value: unknown,
): value is DynamicItemsConfigWithArguments {
  if (
    typeof value === undefined ||
    value === null ||
    typeof value !== 'object'
  ) {
    return false;
  }

  const dummy: DynamicItemsConfigWithArguments = {
    items: [],
  };
  const requiredKeys = Object.keys(dummy);
  return requiredKeys.every((key) => key in value);
}
